import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../../lib/PropTypes';

import styles from '../../../../styles/blocks/employee/call-to-action.module.scss';
import Button from '../../buttons/Button';
import Arrow from '../../icons/Arrow';
import Html from '../../partials/Html';

const propTypes = {
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    body: PropTypes.string,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            colors: AppPropTypes.colors,
        }),
    ),
};

const defaultProps = {
    className: null,
    isContainer: false,
    body: null,
    buttons: null,
};

const CallToAction = ({ className, isContainer, body, buttons }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div
            className={classNames([
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                },
            ])}
        >
            <Html body={body} className={styles.text} />
            {(buttons || []).map(({ text: ctaText = null, url: ctaUrl = null, colors = {} }, i) => {
                const { type: colorType = null, colors: customColors = [] } = colors || {};
                const isGradient = colorType === 'gradient';

                const colorStyles = useMemo(() => {
                    if (colorType === 'color') return { color: customColors[0] };
                    if (colorType === 'gradient')
                        return {
                            backgroundImage: `linear-gradient(to right,  ${customColors[0]}, ${customColors[1]}, ${customColors[0]})`,
                        };
                    return null;
                }, [colorType, customColors]);
                return ctaText !== null ? (
                    <div key={`cta-button-${i + 1}`} className={styles.ctaContainer}>
                        <Arrow className={styles.arrow} />
                        <Button
                            href={ctaUrl}
                            external
                            style={colorStyles}
                            className={classNames([styles.cta, { [styles.animated]: isGradient }])}
                        >
                            {ctaText}
                        </Button>
                    </div>
                ) : null;
            })}
        </div>
    </div>
);
CallToAction.propTypes = propTypes;
CallToAction.defaultProps = defaultProps;

export default CallToAction;
